import { render, staticRenderFns } from "./userDetail.vue?vue&type=template&id=248ae31c&scoped=true"
import script from "./userDetail?vue&type=script&lang=js&external"
export * from "./userDetail?vue&type=script&lang=js&external"
import style0 from "./userDetail.vue?vue&type=style&index=0&id=248ae31c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248ae31c",
  null
  
)

export default component.exports